import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../Pages/Home'
import Login from '../Pages/Login'
import Pricing from '../Pages/Pricing'
import Signup from '../Pages/Signup'

function AllRoutes() {
  return (
    <div>
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/signup" element={<Signup/>}/>
            <Route path="/pricing" element={<Pricing/>}/>
            <Route path="/pricing/marketing" element={<Pricing/>}/>
            <Route path="/pricing/commerce" element={<Pricing/>}/>
            <Route path="/pricing/transactional-email" element={<Pricing/>}/>
        </Routes>
    </div>
  )
}

export default AllRoutes